import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {Router} from '@angular/router';
import {AuthenticationService} from '../authentication-service.service';
import {ViewSubscriptionsService} from '../view-subscriptions.service';

@Component({
  selector: 'app-view-subscriptions',
  templateUrl: './view-subscriptions.component.html',
  styleUrls: ['./view-subscriptions.component.css'],
  providers: [ViewSubscriptionsService]
})
export class ViewSubscriptionsComponent implements OnInit {

  private gridData: any;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ViewSubscriptionsService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null || !IsAdmin.bind(this)) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.componentService.getData().then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.gridData = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  editHandler(event) {
    this.router.navigate(['/manage/subscription'], { queryParams: { id: event.dataItem.id } });
  }

}



// WEBPACK FOOTER //
// ./src/app/view-subscriptions/view-subscriptions.component.ts